import axiosInstanceNew from "../lib/axiosinstanceNew";

const CreditMappingModal = class {
  constructor() {
    this.baseUrl = "/class/credit_mapping/";
    this.staticData = [
      {
        id: 1,
        name: "Mathematics Advanced - Grade 10",
        studentData: [{ name: "Rahul Sharma" }, { name: "Priya Patel" }],
        parentData: {
          first_name: "Mr.",
          last_name: "Sharma",
        },
        tutorData: {
          first_name: "Rajesh",
          last_name: "Kumar",
        },
        price_parent: 15000,
        total_paid: 12000,
        mode: "SME",
        status: "Active",
        lastPayment: "2024-11-05",
        lastClassCycle: {
          id: 101,
        },
      },
      {
        id: 2,
        name: "Science Comprehensive - Grade 9",
        studentData: [
          { name: "Amit Verma" },
          { name: "Sneha Gupta" },
          { name: "Vikram Singh" },
        ],
        parentData: {
          first_name: "Mrs.",
          last_name: "Verma",
        },
        tutorData: {
          first_name: "Priya",
          last_name: "Singh",
        },
        price_parent: 22000,
        total_paid: 18000,
        mode: "COMBINED",
        status: "Active",
        lastPayment: "2024-11-03",
        lastClassCycle: {
          id: 102,
        },
      },
      {
        id: 3,
        name: "English Literature - Grade 8",
        studentData: [{ name: "Karan Patel" }],
        parentData: {
          first_name: "Mr.",
          last_name: "Patel",
        },
        tutorData: {
          first_name: "Amit",
          last_name: "Verma",
        },
        price_parent: 12000,
        total_paid: 8000,
        mode: "SEPARATE",
        status: "Hold",
        lastPayment: "2024-10-28",
        lastClassCycle: {
          id: 103,
        },
      },
      {
        id: 4,
        name: "Social Studies - Grade 7",
        studentData: [{ name: "Meera Joshi" }, { name: "Deepak Kumar" }],
        parentData: {
          first_name: "Mrs.",
          last_name: "Joshi",
        },
        tutorData: {
          first_name: "Sunita",
          last_name: "Gupta",
        },
        price_parent: 18000,
        total_paid: 18000,
        mode: "SME",
        status: "Completed",
        lastPayment: "2024-10-30",
        lastClassCycle: {
          id: 104,
        },
      },
      {
        id: 5,
        name: "Hindi & Sanskrit - Grade 6",
        studentData: [
          { name: "Arjun Reddy" },
          { name: "Pooja Nair" },
          { name: "Ravi Kumar" },
        ],
        parentData: {
          first_name: "Mr.",
          last_name: "Reddy",
        },
        tutorData: {
          first_name: "Vikram",
          last_name: "Patel",
        },
        price_parent: 16000,
        total_paid: 4000,
        mode: "COMBINED",
        status: "Active",
        lastPayment: "2024-11-01",
        lastClassCycle: {
          id: 105,
        },
      },
      {
        id: 6,
        name: "Computer Science - Grade 9",
        studentData: [{ name: "Anjali Sharma" }],
        parentData: {
          first_name: "Mrs.",
          last_name: "Sharma",
        },
        tutorData: {
          first_name: "Rajesh",
          last_name: "Kumar",
        },
        price_parent: 14000,
        total_paid: 2000,
        mode: "SEPARATE",
        status: "Discontinued",
        lastPayment: "2024-09-15",
        lastClassCycle: {
          id: 106,
        },
      },
      {
        id: 7,
        name: "Physics Advanced - Grade 11",
        studentData: [{ name: "Kavita Singh" }, { name: "Rohit Mehta" }],
        parentData: {
          first_name: "Mr.",
          last_name: "Singh",
        },
        tutorData: {
          first_name: "Priya",
          last_name: "Singh",
        },
        price_parent: 25000,
        total_paid: 15000,
        mode: "SME",
        status: "Active",
        lastPayment: "2024-11-07",
        lastClassCycle: {
          id: 107,
        },
      },
    ];
  }

  async List(status, query = []) {
    // Return filtered static data based on status
    return new Promise((resolve) => {
      setTimeout(() => {
        let filteredData = this.staticData;
        status = String(status || "");

        if (status.includes("class_status=All")) {
          // Return all data
        } else if (status.includes("class_status=Active")) {
          filteredData = this.staticData.filter(
            (item) => item.status === "Active"
          );
        } else if (status.includes("class_status=Hold")) {
          filteredData = this.staticData.filter(
            (item) => item.status === "Hold"
          );
        } else if (status.includes("class_status=Completed")) {
          filteredData = this.staticData.filter(
            (item) => item.status === "Completed"
          );
        } else if (status.includes("class_status=Discontinued")) {
          filteredData = this.staticData.filter(
            (item) => item.status === "Discontinued"
          );
        } else if (status.includes("class_type=SME")) {
          filteredData = this.staticData.filter((item) => item.mode === "SME");
        } else if (status.includes("class_type=COMBINED")) {
          filteredData = this.staticData.filter(
            (item) => item.mode === "COMBINED"
          );
        } else if (status.includes("class_type=SEPARATE")) {
          filteredData = this.staticData.filter(
            (item) => item.mode === "SEPARATE"
          );
        }

        resolve({
          data: filteredData,
          meta: {
            current_page: 1,
            per_page: 20,
            total_page: Math.ceil(filteredData.length / 20),
            total: filteredData.length,
          },
        });
      }, 500);
    });
  }

  async ListWithThreeFilters(status, filter1, filter2, query = []) {
    // Handle three filters: status + due classes + completed percentage
    return new Promise((resolve) => {
      setTimeout(() => {
        let filteredData = this.staticData;
        status = String(status || "");

        // Apply status filter
        if (status.includes("class_status=All")) {
          // Return all data
        } else if (status.includes("class_status=Active")) {
          filteredData = filteredData.filter(
            (item) => item.status === "Active"
          );
        } else if (status.includes("class_status=Hold")) {
          filteredData = filteredData.filter((item) => item.status === "Hold");
        } else if (status.includes("class_status=Completed")) {
          filteredData = filteredData.filter(
            (item) => item.status === "Completed"
          );
        } else if (status.includes("class_status=Discontinued")) {
          filteredData = filteredData.filter(
            (item) => item.status === "Discontinued"
          );
        }

        // Apply due classes filter (getDueClasses=true)
        if (filter1.includes("getDueClasses=true")) {
          filteredData = filteredData.filter((item) => {
            const percentage = item.price_parent
              ? ((item.price_parent - (item.total_paid || 0)) /
                  item.price_parent) *
                100
              : 0;
            return percentage > 0; // Classes with outstanding payments
          });
        }

        // Apply completed percentage filter
        if (
          filter2.includes("class_percentage_from") &&
          filter2.includes("class_percentage_to")
        ) {
          const fromMatch = filter2.match(/class_percentage_from=(\d+)/);
          const toMatch = filter2.match(/class_percentage_to=(\d+)/);
          if (fromMatch && toMatch) {
            const fromPercent = parseInt(fromMatch[1]);
            const toPercent = parseInt(toMatch[1]);
            filteredData = filteredData.filter((item) => {
              const percentage = item.price_parent
                ? ((item.total_paid || 0) / item.price_parent) * 100
                : 0;
              return percentage >= fromPercent && percentage <= toPercent;
            });
          }
        }

        resolve({
          data: filteredData,
          meta: {
            current_page: 1,
            per_page: 20,
            total_page: Math.ceil(filteredData.length / 20),
            total: filteredData.length,
          },
        });
      }, 500);
    });
  }

  async ListWithTwoFilters(status, filter, query = []) {
    // Handle two filters: status + one additional filter
    return new Promise((resolve) => {
      setTimeout(() => {
        let filteredData = this.staticData;
        status = String(status || "");

        // Apply status filter
        if (status.includes("class_status=All")) {
          // Return all data
        } else if (status.includes("class_status=Active")) {
          filteredData = filteredData.filter(
            (item) => item.status === "Active"
          );
        } else if (status.includes("class_status=Hold")) {
          filteredData = filteredData.filter((item) => item.status === "Hold");
        } else if (status.includes("class_status=Completed")) {
          filteredData = filteredData.filter(
            (item) => item.status === "Completed"
          );
        } else if (status.includes("class_status=Discontinued")) {
          filteredData = filteredData.filter(
            (item) => item.status === "Discontinued"
          );
        }

        // Apply additional filter
        if (filter.includes("getDueClasses=true")) {
          filteredData = filteredData.filter((item) => {
            const percentage = item.price_parent
              ? ((item.price_parent - (item.total_paid || 0)) /
                  item.price_parent) *
                100
              : 0;
            return percentage > 0; // Classes with outstanding payments
          });
        } else if (
          filter.includes("class_percentage_from") &&
          filter.includes("class_percentage_to")
        ) {
          const fromMatch = filter.match(/class_percentage_from=(\d+)/);
          const toMatch = filter.match(/class_percentage_to=(\d+)/);
          if (fromMatch && toMatch) {
            const fromPercent = parseInt(fromMatch[1]);
            const toPercent = parseInt(toMatch[1]);
            filteredData = filteredData.filter((item) => {
              const percentage = item.price_parent
                ? ((item.total_paid || 0) / item.price_parent) * 100
                : 0;
              return percentage >= fromPercent && percentage <= toPercent;
            });
          }
        }

        resolve({
          data: filteredData,
          meta: {
            current_page: 1,
            per_page: 20,
            total_page: Math.ceil(filteredData.length / 20),
            total: filteredData.length,
          },
        });
      }, 500);
    });
  }
  async Detail(creditMapId) {
    return (
      await axiosInstanceNew.get(
        `${this.baseUrl}view/${creditMapId}?type=creditMapping`
      )
    ).data;
  }
};

export default new CreditMappingModal();
